import React, { useEffect } from 'react'
import ReactGA from 'react-ga'
import RestoreScoll from 'components/RestoreScroll'
import PropTypes from 'prop-types'
import SellerContact from 'components/SellerContact'
import { connect } from 'react-redux'
import { Icon } from '@yapay/design-system'
import RedirectWithTimer from './RedirectWithTimer'
import svgSprite from 'static/img/icons.svg'

export const CardProcessingClickToPay = props => {
  const { transaction } = props.order
  const { panLastFour, digitalCardData } = props.responseCardData

  useEffect(() => {
    ReactGA.event({
      category: 'Card Payment',
      action: 'Processing payment',
    })
  }, [])

  return (
    <div>
      <RestoreScoll />
      <h1 className="m-0">
        <b>Pagamento em andamento!</b>
      </h1>
      <h1 className="mt-0 mb-4">Transação nº {transaction}</h1>
      {props.redirectUrl && (
        <RedirectWithTimer className="mb-8" to={props.redirectUrl} />
      )}

      <div className="flex items-center">
        <div className="mr-4">
          <Icon
            icon="paid"
            width="32"
            height="32"
            className="fill-current text-gray-600"
            url={svgSprite}
          />
        </div>
        <p className="m-0">
          Os dados da transação foram recebidos por nossa equipe.
        </p>
      </div>

      <div className="ml-12">
        <src-card
          card-art={digitalCardData.artUri}
          descriptor-name={digitalCardData.descriptorName}
          account-number-suffix={panLastFour}
          card-status="ACTIVE"
          locale="pt_BR"
        />
      </div>

      <div className="flex items-center my-8">
        <div className="mr-4">
          <Icon
            icon="local-shield"
            width="32"
            height="32"
            className="fill-current text-gray-600"
            url={svgSprite}
          />
        </div>
        <p className="m-0">
          Estamos analisando seu pagamento. Fique atento pois podemos entrar em
          contato para confirmar alguns dados.
        </p>
      </div>

      <div className="flex items-center">
        <div className="mr-4">
          <Icon
            icon="local-post-office"
            width="32"
            height="32"
            className="fill-current text-gray-600"
            url={svgSprite}
          />
        </div>
        <p className="m-0">
          Você será informado por e-mail sobre o andamento do pedido.
        </p>
      </div>

      <SellerContact />
    </div>
  )
}

CardProcessingClickToPay.propTypes = {
  seller: PropTypes.object,
  order: PropTypes.object,
  responseCardData: PropTypes.object,
  redirectUrl: PropTypes.string,
}

const mapStateToProps = state => state

export default connect(mapStateToProps)(CardProcessingClickToPay)
